import Vue from 'vue'
import VueRouter from 'vue-router'

import SgwgPaymentsPage from '@/views/payments-widget/SgwgPaymentsPage'

import SgwgCountersPage from '@/views/counters-widget/SgwgCountersPage'

const SgwgOneFormPage = () => import(/*webpackChunkName: "one-form" */'../views/one-form-widget/SgwgOneFormPage')




import SgwgFindOutAccountPage from '../views/find-out-account/SgwgFindOutAccountPage'
/* import SgWidgetSearchAddress from '../views/SgWidgetSearchUniAddress' */

import SgWidgetSearch from '../views/SgWidgetSearchAccount'


import SgwgError from '@/views/SgwgError'


Vue.use(VueRouter)

const routes = [

  {
    path: '*',
    redirect: {
      name: 'index'
    }
  },
  
  {
    path: '/',
    name: 'index',
  },

  {
    path: '',
    redirect: {
      name: 'index'
    }
  },

  {
    path: '/error',
    name: 'error',
    component: SgwgError,
    props: true
  },

  {
    path: '/search',
    name: 'search',
    component: SgWidgetSearch, 
    props: true
  },

  {
    path: '/counters',
    name: 'counters',
    component: SgwgCountersPage,
    props: true
  },

  {
    path: '/one-form',
    name: 'one-form',
    component: SgwgOneFormPage,
    props: true
  },

  {
    path: '/payments',
    name: 'payments',
    component: SgwgPaymentsPage,
    props: true
  },

  {
    path: '/searchAccount',
    name: 'searchAccount',
    component: SgwgFindOutAccountPage,
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router